import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import isAfter from 'date-fns/isAfter'

import { IsActive } from 'components/Chip'

const Container = styled.div<TSFixMe>`
  color: #6d4f4fb0;
`

export const SeasonEventStatus = ({ seasonEvent }: TSFixMe): TSFixMe => {
  const now = new Date()

  if (seasonEvent.isActive && isAfter(new Date(seasonEvent.endsAt), now)) {
    return (
      <Container>
        <FormattedMessage id="dictionary.expired" defaultMessage="Expired" />
      </Container>
    )
  }

  return <IsActive isActive={seasonEvent.isActive} />
}
